import { Col, Row } from "react-bootstrap";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../../shared/oversight-core/ui-elements/modal-container/modal-container";

interface IProps extends ModelContainerProps {
  show: boolean;
}
const EstimationDeleteModal = (props: IProps) => {
  const { show, ...rest } = props;

  return (
    <ModalContainer
      {...rest}
      title={"Delete Solar Estimation"}
      show={show}
      size="modal-md"
      confirmButtonText="Delete"
      confirmButtonVariant="red"
      cancelButtonText="Cancel"
    >
      <Row>
        <Col className="text-color-2 font-weight-400 font-size-14">
          Are you sure you want to delete this estimation?
        </Col>
      </Row>
    </ModalContainer>
  );
};

export default EstimationDeleteModal;
